import React, { useState, useContext } from 'react';
import {
  QueryProvider, extend,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { ExperienceContext, useConfigService } from '@thd-nucleus/experience-context';
import { Drawer, DrawerItem, DrawerHeader } from '@thd-olt-component-react/drawer';
import { string } from 'prop-types';
import { ErrorBoundary, withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { PSEntryCard } from './project-shopping/ProjectShoppingEntryCard/ProjectShoppingEntryCard';
import { ProjectShoppingImporter } from './project-shopping/ProjectShoppingImporter';
import { EntryCardPlaceholder } from './project-shopping/ProjectShoppingEntryCard/EntryCardPlaceholder';

const PSEntryComponent = ({
  itemId
}) => {

  const [isEntryDrawerOpen, setIsEntryDrawerOpen] = useState(false);
  const [isPSRendered, setIsPSRendered] = useState(false);

  const { channel } = useContext(ExperienceContext);
  const isEntryPointEnabled = useConfigService('fs:ps-entry-point') || false;
  const isMobile = channel === 'mobile';

  const { data } = useDataModel('product', { variables: { itemId }, skip: !itemId });
  const projectDetails = data?.product?.projectDetails;

  const closeMaskOnError = () => {
    const drawerMask = document.querySelector('div[class^=drawer-mask]');
    if (drawerMask) {
      drawerMask.remove();
    }
  };

  if (!isEntryPointEnabled || !projectDetails?.projectId) {
    return null;
  }

  return (
    <ErrorBoundary name="ProjectShoppingEntry" onError={closeMaskOnError}>
      <div data-component="ProjectShoppingEntry">
        <PSEntryCard
          setIsEntryDrawerOpen={setIsEntryDrawerOpen}
          setIsPSRendered={setIsPSRendered}
          projectName={projectDetails?.projectName}
          channel={channel}
          bannerUrl={projectDetails?.bannerUrl?.url}
        />
        <Drawer
          open={isEntryDrawerOpen}
          onClose={() => setIsEntryDrawerOpen(false)}
          initialItem="project-shopping"
          position="right"
          isMobile={isMobile}
          maxSize={isMobile ? 100 : 500}
          zIndex={9998}
        >
          <DrawerItem name="project-shopping">
            <DrawerHeader title="Get Started" />
            {isPSRendered
            && (
              <QueryProvider cacheKey="project-shopping-entry">
                <ProjectShoppingImporter
                  isEntryDrawerOpen={isEntryDrawerOpen}
                  isEntryPoint
                  projectId={projectDetails?.projectId}
                  setIsEntryDrawerOpen={setIsEntryDrawerOpen}
                />
              </QueryProvider>
            )}
          </DrawerItem>
        </Drawer>
      </div>
    </ErrorBoundary>
  );
};

PSEntryComponent.displayName = 'ProjectShoppingEntry';

const propTypes = {
  itemId: string.isRequired
};
PSEntryComponent.propTypes = propTypes;

const defaultProps = {};
PSEntryComponent.defaultProps = defaultProps;

const dataModel = {
  product: params({ itemId: stringType().isRequired() }).shape({
    itemId: stringType(),
    projectDetails: shape({
      projectId: stringType(),
      projectName: stringType(),
      bannerUrl: shape({
        url: stringType()
      })
    })
  })
};
PSEntryComponent.dataModel = dataModel;

const HydratedProjectShopping = withHydrator({
  id: 'project-shopping',
  preserveCtxVal: 'clientStore',
  placeholder: (
    <EntryCardPlaceholder />
  )
}, PSEntryComponent);

const DynamicProjectShopping = withDynamicComponent(HydratedProjectShopping);
export const ProjectShoppingEntry = withErrorBoundary(DynamicProjectShopping);

ProjectShoppingEntry.propTypes = propTypes;
ProjectShoppingEntry.defaultProps = defaultProps;
ProjectShoppingEntry.dataModel = dataModel;